export default "__VITE_ASSET__3d3f4ef9__"